import React, { useEffect, useState } from "react";
// import axios from "axios";
import axios from "../../../context/axios";
import { useNavigate } from "react-router-dom";

const TopCountry = () => {
  const [regions, setRegions] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchDeals = async () => {
      try {
        const res = await axios.get("/top-region-packages");
        console.log("res",res)
        setRegions(res.data.topRegions.slice(0, 6));
      } catch (error) {
        console.error("Error fetching top regions:", error);
      }
    };
    fetchDeals();
  }, []);

  // Custom grid position classes
  const gridClasses = [
    "col-span-2 row-span-1", // 0 - top left
    "col-span-2 row-span-2", // 1 - center tall
    "col-span-2 row-span-1", // 2 - top right
    "col-span-1 row-start-2 row-span-1", // 3 - bottom left top
    "col-span-1 row-start-2 row-span-1", // 4 - bottom left bottom
    "col-span-2 row-span-1", // 5 - bottom right
  ];

  return (
    <div className="py-1 px-1 md:px-0 bg-white">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
        Deals You Can't Miss
      </h2>
      <p className="mb-6 text-gray-600">
        Travel beyond boundaries with incredible savings
      </p>

      <div className="grid grid-cols-6 grid-rows-2 gap-4 auto-rows-[220px]">
        {regions.map((item, idx) => {
          const region = item.region;
          console.log("region",region)
          if (!region) return null;

          return (
            <div
              key={idx}
              onClick={() => {
                console.log("Navigating with regionId:", region.id);
                navigate("/packagelist", { state: { regionId: region.id } });
              }}              className={`relative rounded-xl overflow-hidden group shadow-md cursor-pointer h-full ${gridClasses[idx]}`}
            >
              <img
                src={region.image}
                alt={region.name}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-70" />
              <div className="absolute bottom-3 left-3 text-white">
                <h3 className="text-white  font-semibold">{region.name}</h3>
                {/* <p className="text-sm">5 Nights / 6 Days</p> */}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TopCountry;